<template>
  <div>
    <ts-page-title
      :title="$t('companyProfile.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('companyProfile.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper>
        <a-button type="primary" @click.prevent="addNew">
          {{ $t("addNew") }}
        </a-button>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="tw-whitespace-nowrap">{{ record.prefix_code }}</td>
            <td class="tw-whitespace-nowrap">{{ record.company_name_kh }}</td>
            <td class="tw-whitespace-nowrap">{{ record.company_name_en }}</td>
            <td class="tw-whitespace-nowrap">{{ record.phone }}</td>
            <td>{{ record.company_address }}</td>
            <td>{{ record.company_website }}</td>
            <td>{{ record.facebook_page }}</td>
            <td class="text-center tw-space-x-3">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>

    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('companyProfile.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FromAction from "./form.vue";
export default {
  name: "companyIndex",
  components: {
    FromAction,
  },
  data() {
    return {
      loading: false,
      showForm: false,
    };
  },
  computed: {
    ...mapState("corporate/companyProfile", ["resources", "pagination"]),
    columns() {
      return [
        {
          name: this.$t("companyProfile.prefixCode"),
          style: "width: 5%;white-space: nowrap;",
        },
        {
          name: this.$t("companyProfile.nameKH"),
          style: "width: 15%;white-space: nowrap;",
        },
        {
          name: this.$t("companyProfile.nameEN"),
          style: "width: 15%;white-space: nowrap;",
        },
        {
          name: this.$t("companyProfile.phone"),
          style: "width: 10%;white-space: nowrap;",
        },
        {
          name: this.$t("companyProfile.address"),
          style: "width: 400px;white-space: nowrap;",
        },
        {
          name: this.$t("companyProfile.website"),
          style: "width: 15%;white-space: nowrap;",
        },
        {
          name: this.$t("companyProfile.facebookPage"),
          style: "width: 10%;white-space: nowrap;",
        },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 5%;",
        },
      ];
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("corporate/companyProfile/fetch", { ...attributes })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    addNew() {
      this.showForm = true;
    },
    edit(record) {
      this.$store.commit("corporate/companyProfile/SET_EDIT_DATA", record);
      this.showForm = true;
    },
    clearEdit() {
      this.$store.commit("corporate/companyProfile/SET_EDIT_DATA", {});
      this.showForm = false;
      this.fetchData();
    },
    deleteRecord(record) {
      record._deleting = true;
      this.$store
        .dispatch("corporate/companyProfile/destroy", record.company_id)
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
  },
  watch: {},
  beforeRouteLeave(to, from, next) {
    this.$store.commit("corporate/companyProfile/RESET_STATE");
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
};
</script>
